<template>
  <div class="inventory">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
      <el-form-item label="药品名称" label-width="70px">
        <el-input style="width: 140px"  clearable v-model="searchForm.name" placeholder="请输入药品名称"></el-input>
      </el-form-item>
      <el-form-item label="药品编码">
        <el-input style="width: 140px"   clearable v-model="searchForm.drugCode" placeholder="请输入药品编码"></el-input>
      </el-form-item>
      <el-form-item label="生产批号">
        <el-input style="width: 140px"   clearable v-model="searchForm.batchNumber" placeholder="请输入生产批号"></el-input>
      </el-form-item>
      <el-form-item label="即将用尽">
        <el-select v-model="searchForm.runoutwarning" placeholder="请选择">
          <el-option label="是" value="true"></el-option>
          <el-option label="否" value="false"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="过期筛选">
        <el-select v-model="searchForm.outValidity" placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option label="是" value="true"></el-option>
          <el-option label="否" value="false"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="即将过期">
        <el-select v-model="searchForm.timewarning" placeholder="请选择">
          <el-option label="是" value="true"></el-option>
          <el-option label="否" value="false"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%">
        <el-table-column
            prop="name"
            min-width="70"
            label="药品名称">
        </el-table-column>
        <el-table-column
            prop="code"
            label="药品编码">
        </el-table-column>
        <el-table-column
            prop="createTime"
            label="创建时间"
            align="center">
        </el-table-column>
        <el-table-column
            prop="batchNumber"
            align="center"
            label="药品批号">
        </el-table-column>
        <el-table-column
            prop="validity"
            align="center"
            label="有效期">
        </el-table-column>
        <el-table-column
            prop="validityUnit"
            align="center"
            label="有效期单位">
        </el-table-column>
        <el-table-column
            prop="outValidityDate"
            align="center"
            label="失效日期">
        </el-table-column>
        <el-table-column
            prop="inventoryAmount"
            align="center"
            label="库存量">
        </el-table-column>
        <el-table-column
            prop="inventoryAmountUnit"
            align="center"
            label="库存量单位">
        </el-table-column>
        <el-table-column
            prop="factoryName"
            align="center"
            label="生产厂家名称">
        </el-table-column>
        <el-table-column
            prop="safeRemain"
            align="center"
            label="安全存量值">
        </el-table-column>
        <el-table-column
            prop="manufactureDate"
            align="center"
            label="生产日期">
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="margin-top: 20px">
      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'
                  @handleCurrentChange='handleCurrentChange'></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import {pickerOptions} from "@/service/common";
export default {
  name: "inventory",
  data() {
    return {
      tableData: [],
      pickerOptions:pickerOptions,
      searchForm: {},
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
    }
  },
  components: {
    //someComponent
    Pagination
  },
  methods: {
    //搜索
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    clear(){
      this.searchForm={}
    },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },
    // list
    init() {
      let data = {
        ...this.searchForm,
        page: this.currPage,
        pageSize: this.pageSize,
      }
      this.axios
          .get("/api/Inventory", {params: data})
          .then((res) => {
            this.tableData = res.list
            this.tableData.forEach(item => {
              if (item.createTime) {
                item.createTime = this.dayjs(item.createTime).format('YYYY/MM/DD')
              }
              if (item.outValidityDate) {
                item.outValidityDate = this.dayjs(item.outValidityDate).format('YYYY/MM/DD')
              }
              if (item.manufactureDate) {
                item.manufactureDate = this.dayjs(item.manufactureDate).format('YYYY/MM/DD')
              }
            })
            this.total = res.count
          })
    }
  },
  mounted() {
    //
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.inventory {

}
</style>